import lightTheme from '../components/style/lightTheme';

const MuiDialogTitle = {
  styleOverrides: {
    root: {
      padding: '1.5rem',
      backgroundColor: lightTheme.bg,
    },
  },
};

export default MuiDialogTitle;
